/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ParameterTimeSeriesConfigurationThresholdsInner
 */
export interface ParameterTimeSeriesConfigurationThresholdsInner {
    /**
     * 
     * @type {string}
     * @memberof ParameterTimeSeriesConfigurationThresholdsInner
     */
    'threshold_type': ParameterTimeSeriesConfigurationThresholdsInnerThresholdTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ParameterTimeSeriesConfigurationThresholdsInner
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof ParameterTimeSeriesConfigurationThresholdsInner
     */
    'color': ParameterTimeSeriesConfigurationThresholdsInnerColorEnum;
}

export const ParameterTimeSeriesConfigurationThresholdsInnerThresholdTypeEnum = {
    Min: 'min',
    Max: 'max'
} as const;

export type ParameterTimeSeriesConfigurationThresholdsInnerThresholdTypeEnum = typeof ParameterTimeSeriesConfigurationThresholdsInnerThresholdTypeEnum[keyof typeof ParameterTimeSeriesConfigurationThresholdsInnerThresholdTypeEnum];
export const ParameterTimeSeriesConfigurationThresholdsInnerColorEnum = {
    Red: 'red',
    Orange: 'orange'
} as const;

export type ParameterTimeSeriesConfigurationThresholdsInnerColorEnum = typeof ParameterTimeSeriesConfigurationThresholdsInnerColorEnum[keyof typeof ParameterTimeSeriesConfigurationThresholdsInnerColorEnum];


